<script setup lang="ts">
type Props = {
  phone: string
  text?: string
}

const props = defineProps<Props>()
</script>

<template>
  <a class="base-phone" :href="`tel:${props.phone}`" target="_self">
    {{ text ?? phone }}
  </a>
</template>
<style lang="scss">
.base-phone {
  color: inherit;
  text-decoration: none;
}
</style>
